import { apiBaseUrl } from './constants'

const scrubDonationCategories = (allDonationCategories, userDonationCategories) => {
  return allDonationCategories.map((category) => {
    category.childCategories = category.childCategories.filter(({ id }) => userDonationCategories.includes(id))
    return category
  }).filter(({ id }) => userDonationCategories.includes(id))
}

export default {
  login ({ loginId, password }) {
    const headers = new Headers({
      'Content-Type': 'application/json'
    })
    return fetch(`${apiBaseUrl}/auth/user`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        username: loginId,
        password
      })
    })
      .then(res => res.json())
      .then((res) => {
        res.data.donationCategories = scrubDonationCategories(res.data.donationCategories, res.data.otherInfo.donationCategories)
        return res
      })
      .catch(err => console.log(err))
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js